import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-brand-50">
      <h1 className="text-6xl font-bold text-brand-700">404</h1>
      <p className="mt-4 text-lg text-gray-600">Страница не найдена</p>
      <Link
        to="/dashboard"
        className="mt-6 rounded-lg bg-brand-600 px-6 py-2 text-sm font-medium text-white hover:bg-brand-700"
      >
        На главную
      </Link>
    </div>
  );
}
